import React from 'react';
import { theme } from '@robinpowered/ui-kit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChairOffice } from '@awesome.me/kit-cf858715fd/icons/classic/solid';
import {
  ResultIconTile,
  ResultName,
  ResultSubtext,
  ResultText,
} from '../styles';
import { InteractiveResultRow } from './InteractiveResultRow';
import type { DeskSearchHit } from '../types';

interface DeskResultProps {
  result: DeskSearchHit;
  onSelect?: (result: DeskSearchHit) => void;
}

export const DeskResult: React.FC<DeskResultProps> = ({ result, onSelect }) => {
  const { token } = theme.useToken();
  const location = [result.levelName, result.locationName]
    .filter(Boolean)
    .join(', ');
  const handleSelect = onSelect ? () => onSelect(result) : undefined;

  return (
    <InteractiveResultRow onSelect={handleSelect}>
      <ResultIconTile
        aria-hidden="true"
        style={{ background: token.colorFillQuaternary }}
      >
        <FontAwesomeIcon icon={faChairOffice} />
      </ResultIconTile>
      <ResultText>
        <ResultName>{result.displayName}</ResultName>
        {location && <ResultSubtext>{location}</ResultSubtext>}
      </ResultText>
    </InteractiveResultRow>
  );
};
